import dynamic from "next/dynamic";

const DynamicAddCardModal = dynamic(
  () =>
    import("modules/cards/actions/components/AddCardModal").then(
      (mod) => mod.AddCardModal
    ),
  {
    loading: () => <></>,
  }
);

export default DynamicAddCardModal;
